import React, { useCallback, useEffect, useState, memo, useRef } from "react";
import { useSelector } from 'react-redux';
import {
    Grid, Button, LinearProgress, Badge, Modal,
    Table, TableBody, TableCell, TableContainer,
    FormControl, Select, InputLabel, MenuItem,
    TableHead, TableRow, Typography, Box, Tooltip, IconButton,
    Checkbox
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Check from "@mui/icons-material/Check";
import { analytics } from "../../hooks/use-analytics";

export default function AnnouncementPopup(props) {
    const { auth, app } = useSelector(state => state);
    const { user, profile } = auth;
    const { app_state, ui_state } = app.current_state;

    let tourListData_xx = {
        notShowAgain: false,
        label: "New Features and Improvements",
        tourList: [
            {
                id: 1,
                title: "Events and Holidays",
                videoUrl: "", // If present, show video by default.
                imageUrl: "https://images5.alphacoders.com/440/440286.jpg",
                description: "This description will show under the image or video",
                know_more: "https://www.google.com" // mandatory
            },
            {
                id: 2,
                title: "Buisness Builder",
                videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
                imageUrl: "",
                description: "This description will show under the image or video",
                know_more: "https://www.google.com"
            },
            {
                id: 3,
                title: "Expanded View",
                videoUrl: "",
                imageUrl: "https://img.freepik.com/free-photo/beautiful-rustic-house-landscape_23-2151918074.jpg",
                description: "This description will show under the image or video",
                know_more: "https://www.google.com"
            }
        ]
    };
    const tourListApiData = localStorage.getItem('tourListApiData');
    let tourListData = JSON.parse(tourListApiData);
    
    const [tourListDetails, setTourListDetails] = useState(tourListData);
    const [selectedOption, setSelectedOption] = useState(tourListData?.tourList[0]?.id);

    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const togglePlayPause = () => {
        if (videoRef.current.paused) {
            videoRef.current.play();
            setIsPlaying(true);
        } else {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    };

    const handleChange = (event) => {
        const { checked } = event.target;
        console.log("checked =>>",checked);
        localStorage.setItem('tours_not_show_again', checked);
        setTourListDetails((prevDetails) => ({
            ...prevDetails,
            notShowAgain: checked,
        }));
    };

    const changeSelectedOption = (id, title = null) => {
        setSelectedOption(id);
        setIsPlaying(false);
        analytics.track("announcement_tour_clicked", { tour_title: title });
    };

    const handlePrevNextMedia = (key, index) => {
        if (key === "prev") {
            index = index - 1
        }
        if (key === "next") {
            index = index + 1
        }
        changeSelectedOption(tourListDetails.tourList[index].id, tourListDetails.tourList[index].title);
    };

    const cleanUrl = url => url.replace(/\\"|&quot;/g, '').trim();
    return (
        <Box className="announcement-popup-wrap">
            <div className="announcement-heading">
                <svg className="cross-btn" onClick={props.handleClose} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#333333" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>
                {tourListDetails?.label}
            </div>
            <Box className="announcement-body">
                <Box className="left-section">
                    <div className="announcement-list">
                        {/* {tourListDetails?.tourList.map((option) => ( */}
                        {(tourListDetails?.tourList || []).map((option) => (
                            <Box
                                key={option.id}
                                onClick={() => changeSelectedOption(option.id, option.title)}
                                className={`announcement-title ${selectedOption === option.id ? "active" : ""}`}
                            >
                                <div>{option.title}</div>
                                {
                                    selectedOption === option.id ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#01A4EF" viewBox="0 0 256 256"><path d="M176,128,96,208V48Z" opacity="0.2"></path><path d="M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z"></path></svg>
                                        :
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#01A4EF" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
                                }
                            </Box>
                        ))}
                    </div>
                    <Box className="dont-show-again">
                        <Checkbox
                            className="custom-checkbox"
                            onChange={(e) => {
                                handleChange(e);
                            }}
                            checked={tourListDetails?.notShowAgain}
                        />
                        <div
                            onClick={() => handleChange({ target: { checked: !tourListDetails.notShowAgain } })}
                            style={{ cursor: "pointer" }}
                        >
                            Don't show again
                        </div>
                    </Box>
                </Box>
                <Box className="right-section">
                    {/* {tourListDetails?.tourList.map((option, index) => */}
                    {(tourListDetails?.tourList || []).map((option, index) => 
                        selectedOption === option.id && (
                            <Box key={option.id}>
                                <div className="announcement-media">
                                    <svg onClick={() => option.know_more && window.open(option.know_more, "_blank")} className={`know-more-button ${!option.know_more ? "dn" : ""}`} width="100" height="34" viewBox="0 0 93 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M81 0H0C3.31 0 6.31 1.34 8.49 3.51C10.66 5.68 12 8.68 12 12V10C12 16.63 17.37 22 24 22H81C84.31 22 87.31 23.34 89.49 25.51C91.66 27.68 93 30.68 93 34V12C93 5.37 87.63 0 81 0Z" fill="white" />
                                        <path d="M26.7754 11H25.7207L27.5195 2.54492H28.5684L27.6953 6.65234H27.7891L32.3125 2.54492H33.6895L29.5762 6.26562L32.207 11H30.9766L28.7441 6.91602L27.4023 8.11133L26.7754 11ZM33.4961 11L34.8379 4.68359H35.8164L35.6172 5.62695H35.7109C36.2031 4.92383 36.8418 4.57227 37.627 4.57227C38.2129 4.57227 38.6836 4.75781 39.0391 5.12891C39.3945 5.5 39.5723 5.94727 39.5723 6.4707C39.5723 6.68945 39.5449 6.93164 39.4902 7.19727L38.6816 11H37.6562L38.4297 7.37305C38.4805 7.12695 38.5059 6.92188 38.5059 6.75781C38.5059 6.37109 38.3906 6.0625 38.1602 5.83203C37.9336 5.59766 37.6133 5.48047 37.1992 5.48047C36.7266 5.48047 36.3242 5.63477 35.9922 5.94336C35.6641 6.25195 35.4473 6.65234 35.3418 7.14453L34.5215 11H33.4961ZM41.9102 8.375C41.9102 8.92188 42.0605 9.36328 42.3613 9.69922C42.6621 10.0352 43.0586 10.2031 43.5508 10.2031C43.9375 10.2031 44.2949 10.0781 44.623 9.82812C44.9512 9.57812 45.209 9.24023 45.3965 8.81445C45.5879 8.38477 45.6836 7.91797 45.6836 7.41406C45.6836 6.8125 45.543 6.33984 45.2617 5.99609C44.9805 5.65234 44.5918 5.48047 44.0957 5.48047C43.4434 5.48047 42.916 5.74805 42.5137 6.2832C42.1113 6.81445 41.9102 7.51172 41.9102 8.375ZM43.4219 11.1113C42.6562 11.1113 42.0332 10.8691 41.5527 10.3848C41.0762 9.90039 40.8379 9.27148 40.8379 8.49805C40.8379 7.34961 41.1504 6.4082 41.7754 5.67383C42.4043 4.93945 43.209 4.57227 44.1895 4.57227C44.9551 4.57227 45.5742 4.8125 46.0469 5.29297C46.5234 5.77344 46.7617 6.40039 46.7617 7.17383C46.7617 7.91992 46.6172 8.59375 46.3281 9.19531C46.043 9.79688 45.6445 10.2676 45.1328 10.6074C44.625 10.9434 44.0547 11.1113 43.4219 11.1113ZM56.6816 4.68359L53.5645 11H52.5391L52.1289 6.1543H52.0352L49.627 11H48.6074L48.1855 4.68359H49.1055L49.3926 9.68164H49.4863L51.8945 4.68359H52.9199L53.2539 9.73438H53.3477L55.668 4.68359H56.6816ZM61.2051 11H60.1973L61.9961 2.54492H63.168L64.5859 9.54102H64.6797L69.0508 2.54492H70.3516L68.5527 11H67.5449L68.916 4.54297H68.8457L64.832 10.9414H63.9414L62.6465 4.54297H62.5762L61.2051 11ZM71.957 8.375C71.957 8.92188 72.1074 9.36328 72.4082 9.69922C72.709 10.0352 73.1055 10.2031 73.5977 10.2031C73.9844 10.2031 74.3418 10.0781 74.6699 9.82812C74.998 9.57812 75.2559 9.24023 75.4434 8.81445C75.6348 8.38477 75.7305 7.91797 75.7305 7.41406C75.7305 6.8125 75.5898 6.33984 75.3086 5.99609C75.0273 5.65234 74.6387 5.48047 74.1426 5.48047C73.4902 5.48047 72.9629 5.74805 72.5605 6.2832C72.1582 6.81445 71.957 7.51172 71.957 8.375ZM73.4688 11.1113C72.7031 11.1113 72.0801 10.8691 71.5996 10.3848C71.123 9.90039 70.8848 9.27148 70.8848 8.49805C70.8848 7.34961 71.1973 6.4082 71.8223 5.67383C72.4512 4.93945 73.2559 4.57227 74.2363 4.57227C75.002 4.57227 75.6211 4.8125 76.0938 5.29297C76.5703 5.77344 76.8086 6.40039 76.8086 7.17383C76.8086 7.91992 76.6641 8.59375 76.375 9.19531C76.0898 9.79688 75.6914 10.2676 75.1797 10.6074C74.6719 10.9434 74.1016 11.1113 73.4688 11.1113ZM77.6172 11L78.959 4.68359H79.9316L79.7617 5.48633H79.8555C80.2617 4.87695 80.8262 4.57227 81.5488 4.57227C81.8887 4.57227 82.1348 4.60156 82.2871 4.66016L82.0703 5.62695C81.8438 5.57617 81.5781 5.55078 81.2734 5.55078C80.7656 5.55078 80.3613 5.68945 80.0605 5.9668C79.7637 6.24414 79.5527 6.67773 79.4277 7.26758L78.6367 11H77.6172ZM85.0293 11.1113C84.2949 11.1113 83.6836 10.877 83.1953 10.4082C82.707 9.93945 82.4629 9.29297 82.4629 8.46875C82.4629 7.30859 82.7676 6.36914 83.377 5.65039C83.9902 4.93164 84.7812 4.57227 85.75 4.57227C86.4297 4.57227 86.998 4.80078 87.4551 5.25781C87.916 5.71094 88.1484 6.33398 88.1523 7.12695C88.1523 7.46289 88.127 7.7793 88.0762 8.07617H83.5234C83.5156 8.2168 83.5117 8.32227 83.5117 8.39258C83.5117 8.70508 83.5566 8.98047 83.6465 9.21875C83.7402 9.45703 83.8633 9.64453 84.0156 9.78125C84.1719 9.91797 84.3398 10.0215 84.5195 10.0918C84.7031 10.1582 84.8945 10.1914 85.0938 10.1914C85.8633 10.1914 86.3926 9.92383 86.6816 9.38867H87.7539C87.6211 9.89258 87.3125 10.3066 86.8281 10.6309C86.3438 10.9512 85.7441 11.1113 85.0293 11.1113ZM83.6582 7.26172H87.0859C87.0938 7.21484 87.0977 7.12695 87.0977 6.99805C87.0977 6.56055 86.9707 6.19531 86.7168 5.90234C86.4668 5.60938 86.1133 5.46289 85.6562 5.46289C85.1797 5.46289 84.7637 5.625 84.4082 5.94922C84.0566 6.27344 83.8066 6.71094 83.6582 7.26172Z" fill="#01A4EF" />
                                    </svg>

                                    {/* {option.videoUrl !== "" ? (
                                        <video
                                            ref={videoRef}
                                            className="announcement-video"
                                            autoPlay
                                            muted
                                            loop
                                        //controls
                                        >
                                            <source src={option.videoUrl} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>

                                    ) : option.imageUrl !== "" ? (
                                        <img className="announcement-image" src={option.imageUrl} alt={option.title} />
                                    ) : (
                                        <img className="announcement-image" src="https://www.mrtruant.com/website/images/no-data-found.png" alt="No Data Found" />
                                    )} */}

                                    {option.videoUrl ? (
                                        <video
                                            ref={videoRef}
                                            className="announcement-video"
                                            controls
                                            //autoPlay
                                            //muted
                                            //loop
                                        >
                                            <source src={cleanUrl(option.videoUrl)} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    ) : option.imageUrl ? (
                                        <img className="announcement-image" src={option.imageUrl} alt={option.title} />
                                    ) : (
                                        <img className="announcement-image" src="https://www.mrtruant.com/website/images/no-data-found.png" alt="No Data Found" />
                                    )}

                                    <div className="announcement-description display-none">{option.description}</div>

                                    <div className={`media-player ${isPlaying ? "" : "paused"}`}>
                                        <div
                                            className={`prev-btn ${index === 0 ? "disabled" : ""}`}
                                            onClick={() => handlePrevNextMedia("prev", index)}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path></svg>
                                        </div>
                                        <div style={{display:"none"}}
                                            className={`video-play-pause-btn ${option.videoUrl && option.videoUrl !== "" ? "" : "disabled"}`}
                                            onClick={togglePlayPause}
                                        >
                                            {isPlaying ?
                                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#fff" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM112,96v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z"></path></svg>
                                                :
                                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#fff" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48.24-94.78-64-40A8,8,0,0,0,100,88v80a8,8,0,0,0,12.24,6.78l64-40a8,8,0,0,0,0-13.56ZM116,153.57V102.43L156.91,128Z"></path></svg>
                                            }
                                        </div>
                                        <div
                                            className={`next-btn ${index === tourListDetails.tourList.length - 1 ? "disabled" : ""}`}
                                            onClick={() => handlePrevNextMedia("next", index)}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" viewBox="0 0 256 256"><path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        )
                    )}
                </Box>
            </Box>
        </Box>
    )
}


